import {booleanAttribute, Component, computed, input} from "@angular/core";
import {TranslateModule} from "@ngx-translate/core";
import {erMigrertBeslutning} from "felles-ng2/modell/beslutningModellHjelpere";
import {erIkkeTomStreng} from "felles-ng2/støttefunksjoner/strenger";
import {standard} from "felles-ng2/støttefunksjoner/nilsjekk";
import {HtmlFormatertKomponent} from "web-ng2/delt/komponenter/html-formatert/html-formatert";
import {BeslutningModellDLM} from "felles-ng2/tjenester/datalager/BeslutningDatatjeneste";
import {EntitetikonKomponent} from "web-ng2/delt/komponenter/entitetikon/entitetikon";

/**
 * Listevisning av beslutning for protokoll, for visning i møteprotokoll.
 * Kan vise enten vedtatt beslutning eller forslag til beslutning.
 */
@Component({
    selector: 'beslutning-listevisning-protokoll',
    templateUrl: 'beslutning-listevisning-protokoll.html',
    styleUrl: 'beslutning-listevisning-protokoll.scss',
    imports: [
        HtmlFormatertKomponent,
        TranslateModule,
        HtmlFormatertKomponent,
        EntitetikonKomponent
    ],
    standalone: true
})
export class BeslutningListevisningProtokollKomponent {

    beslutning = input.required<BeslutningModellDLM>();

    /** Når sann vises tittelForslag og beskrivelseForslag, ellers vises tittel og beskrivelse */
    visForslag = input(false, {transform: booleanAttribute});

    /** Beslutning migrert fra sp2 vil ikke ha tittel, kun beskrivelse */
    harTittel = computed(() => !erMigrertBeslutning(this.beslutning()));

    harBeskrivelse = computed(() => erIkkeTomStreng(this.beskrivelse()));

    tittel = computed(() => standard(this.visForslag() ? this.beslutning().tittelForslag : this.beslutning().tittel, ''));

    beskrivelse = computed(() => this.visForslag() ? this.beslutning().beskrivelseForslag : this.beslutning().beskrivelse);

}
